import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, collection, addDoc, getDocs, doc, deleteDoc, updateDoc } from 'firebase/firestore';

// Configurația aplicației Firebase
const firebaseConfig = {
  apiKey: "AIzaSyAs6wcK5Zaqq2xmOrVxWL5_YuJUHl2-wS8",
  authDomain: "uniquely-sharp.firebaseapp.com",
  projectId: "uniquely-sharp",
  storageBucket: "uniquely-sharp.firebasestorage.app",
  messagingSenderId: "565026393126",
  appId: "1:565026393126:web:3ac214ff8919bbec0ceae7"
};

// Inițializarea aplicației Firebase
const app = initializeApp(firebaseConfig);

// Inițializăm autentificarea și Firestore
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db, collection, addDoc, getDocs, doc, deleteDoc, updateDoc };
